import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  addHistoryNoti,
  addNotification,
  changeQActionOrder,
  getDetailOfOrder,
  pushNotifications,
  removeNotification,
  updateOrderSelected
} from '@slice/orderManager.slice';
import { RootState } from 'app/store';
import { useCallback, useEffect } from 'react';
import toast from 'react-hot-toast/headless';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FcmMsg } from './useFcmMessages';
import { DivToast } from './WapperNotification';

const ORDER_PATH = '/quan-ly-don-hang';

export function useOrderNotification() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const history = useNavigate();
  const notification = useSelector((s: RootState) => s.orderManager.notification);
  const isACNotify = useSelector((s: RootState) => s.orderManager.isACNotify);

  // cần xử lý như dạng này nếu đơn này chưa có trong list đơn bên menu quản lý đơn
  const handleMenu = (maDonHang: string, orderTypeId?: number, isTransactionRoute?: boolean) => {
    if (isTransactionRoute) {
      history('/kho-ky-thuat?tab=2');
      return;
    }
    history(`${ORDER_PATH}?maDonHang=${maDonHang}`);
  };

  const handleDetail = (maDonHang: string, orderTypeId?: number, isTransactionRoute?: boolean) => {
    if (isTransactionRoute) {
      handleMenu(maDonHang, orderTypeId, true);
      toast.remove(maDonHang);
      return;
    }

    if (window.location.pathname !== ORDER_PATH) {
      handleMenu(maDonHang, orderTypeId);
      toast.remove(maDonHang);
      return;
    }

    dispatch(getDetailOfOrder({ maDonHang, typeOrder: +orderTypeId, forceOpen: true }));
    dispatch(removeNotification({ maDonHang, clearAll: false }));
  };

  const handleQActions = (maDonHang: string, orderTypeId?: number) => {
    dispatch(updateOrderSelected(maDonHang));
    dispatch(changeQActionOrder(true));
  };

  // Nhận tin thô từ useFcmMessages (cả foreground lẫn chạy nền) -> đẩy vào redux
  const onOrderMessage = useCallback((msg: FcmMsg) => {
    dispatch(pushNotifications(msg));
  }, []);

  // Redux có notification mới -> lưu, hiện toast, refresh đơn nếu đang ở trang đơn
  useEffect(() => {
    if (!notification) return;

    batch(() => {
      dispatch(addNotification(notification)); // thêm vào thông báo save
      dispatch(addHistoryNoti(notification)); // thêm vào lịch sử thông báo save
    });

    toast(
      <DivToast
        notification={notification}
        handleDetail={handleDetail}
        handleMenu={handleMenu}
        handleQActions={handleQActions}
      />,
      {
        id: notification.maDonHang,
        duration: isACNotify ? 10000 : 60000 * 60
      }
    );

    // thêm vào ds đơn hàng nếu đang ở menu ds đơn hàng
    const typeOrder = Number(notification.body?.orderTypeId);
    if (window.location.pathname === ORDER_PATH && !Number.isNaN(typeOrder)) {
      dispatch(getDetailOfOrder({ maDonHang: notification.maDonHang, typeOrder }));
    }

    // bật xong thì xoá đi
    dispatch(pushNotifications(null));
  }, [notification?.maDonHang]);

  return { onOrderMessage };
}
